import request from 'project-config/services/request/request'
import getHttpHeader from 'project-config/services/request/get-http-header'
import { UserInfo } from './type'

export const GlobalAPI = Object.freeze({
  queryUser: (headers?: object) => {
    return request.post<UserInfo>('/api/rendering/user/queryUser', null, {
      config: {
        headers: {
          ...getHttpHeader(),
          ...headers,
        },
      },
    })
  },
})
